// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"eef2c29a7c393f93","3037":"df64fa7e26d75afa","6332":"6c2d99b1a917323f","7681":"734e6fa88ad1d350"}[chunkId] + ".css";
};